import { useMutation, useQueryClient } from "@tanstack/react-query"
import toast from "react-hot-toast";
import { addProduct as addProductAPI } from "services/apiProduct";

const useAddProducts = () => {

    const queryClient = useQueryClient();
    const{isPending:isAdding,isSuccess:isAdded,mutate: addProduct} = useMutation({
        mutationFn: addProductAPI,
        onSuccess:(data)=>{
            queryClient.setQueryData(['newProduct'],data)
            toast.success("Product added Successfully")
            queryClient.invalidateQueries({queryKey:['productList']})
            queryClient.invalidateQueries({queryKey:['appInitData']})
        
        },
        onError:(error)=>{
            console.log("Error occurred while adding products",error)
            if(error?.data && typeof error.data === "object"){
                for (const key in error.data){
                    const msg = error.data[key];
                    toast.error(Array.isArray(msg) ? msg[0] : msg)
                }
            }else{
                toast.error(error.message || 'Something went wrong')
            }
        }

    })

    return{isAdding,isAdded,addProduct}
}

export default useAddProducts
